import { PureComponent } from 'preact-compat'

import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'
import { assignModerator, unassignModerator } from '../services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'

/* eslint-disable import/no-internal-modules */
import { User } from '@insided/deprecated-preact-components/user-selector/User'
import DynamicUserList from '@insided/deprecated-preact-components/list-selector/DynamicUserList'

export interface AssignModeratorProps {
  topicId: number
  contentType: ContentType
  assignedModerator?: User
  onModeratorAssigned: (moderator?: User) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

class AssignModerator extends PureComponent<AssignModeratorProps> {
  constructor(props: AssignModeratorProps) {
    super(props)
    this.onModeratorAssigned = this.onModeratorAssigned.bind(this)
    this.onModeratorUnassigned = this.onModeratorUnassigned.bind(this)
    this.headerOnClick = this.headerOnClick.bind(this)
  }

  async onModeratorAssigned(newModerator: User) {
    const { topicId, contentType, onModeratorAssigned, onShowAlert } = this.props
    try {
      await assignModerator(contentType, [topicId], newModerator.id as number)
      onModeratorAssigned(newModerator)
      onShowAlert('success', `Assigned to ${newModerator.name}!`)
    } catch {
      onShowAlert('error')
    }
  }

  async onModeratorUnassigned() {
    const { topicId, contentType, onModeratorAssigned, onShowAlert } = this.props
    try {
      await unassignModerator(contentType, [topicId])
      onModeratorAssigned(undefined)
      onShowAlert('success', 'Unassigned!')
    } catch {
      onShowAlert('error')
    }
  }

  headerOnClick(assigned: boolean, close: () => void) {
    return async () => {
      if (assigned) {
        await this.onModeratorUnassigned()
        return close()
      }
      const payload = {
        id: getInsidedData('user').userid,
        name: getInsidedData('user').name
      }
      await this.onModeratorAssigned(payload)
      return close()
    }
  }

  render() {
    const { assignedModerator } = this.props
    return (
      <DynamicUserList
        header={(close) => (
          <div
            className='list-selector-header'
            onClick={this.headerOnClick(Boolean(assignedModerator), close)}
          >
            {assignedModerator ? 'Unassign' : 'Assign to me'}
          </div>
        )}
        icon='arrowDropdown'
        buttonTitle={assignedModerator ? assignedModerator.name : 'Assign moderator'}
        onUserClick={this.onModeratorAssigned}
        placeholder='Search for moderator'
        fetchUrl='/member/getModerators?query='
        feature='assign-moderator'
      />
    )
  }
}

export default AssignModerator
